



































































import { Component, Prop, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
import { IPageConfig } from "@/@types/filoxenia-config/nav-bar";
import { FOLDER_ROUTE } from "@/services/nav-panel/nav-model";

@Component({ components: { draggable } })
class NavDropZone extends Vue {
  @Prop({ type: Array, default: () => [] }) items!: Array<IPageConfig>;
  @Prop({ type: String, required: true }) kind!: string;
  @Prop({ type: String, required: true }) groupKey!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) removable!: boolean;
  @Prop({ type: String, default: "" }) emptyText!: string;

  iconFolder = "main/configuration/icons";

  get group(): { name: string } {
    return { name: "nav-panel-2" };
  }

  gridOf(item: IPageConfig): number {
    const grid = Number(item.grid) || 1;
    return Math.max(1, Math.min(4, grid));
  }

  childrenCount(item: IPageConfig): number {
    return (item.navigation?.children || item.children || []).length;
  }

  isFolderPage(item: IPageConfig): boolean {
    return item.route === FOLDER_ROUTE;
  }

  imageOf(item: IPageConfig): string {
    const src = item.src;
    if (!src) return "";
    const name = src.svg || (typeof src.icon === "string" ? src.icon : "");
    if (!name) return "";
    const svgName = name.endsWith(".svg") ? name : `${name}.svg`;
    return this.$getWebImage(svgName, this.iconFolder);
  }

  iconOf(item: IPageConfig): string {
    const icon = item.src?.icon;
    if (icon && typeof icon === "object" && icon.icon) return icon.icon;
    if (this.isFolderPage(item)) return "folder2";
    return "circle";
  }

  titleOf(item: IPageConfig): string {
    const parts = [this.$getLocale(item.name)];
    if (item.lock) parts.push(String(this.$i18n.t("configuration.nav20.lock")));
    if (this.kind === "grid") {
      parts.push(
        `${String(this.$i18n.t("configuration.nav20.grid"))}: ${this.gridOf(
          item
        )}`
      );
    }
    return parts.join(" · ");
  }
}
export default NavDropZone;
